export const Enkrypt = () => (
  <svg
    viewBox="0 0 32 32"
    width="100%"
    height="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6.15778C0 2.75671 2.75698 0 6.15778 0H32V4.72485C32 7.16928 30.0186 9.15072 27.5741 9.15072H15.4242C12.0231 9.15072 9.26641 11.9077 9.26641 15.3088V16.8756C9.26641 20.2767 12.0231 23.0333 15.4242 23.0333H27.5741C30.0186 23.0333 32 25.015 32 27.4595V32.0003H6.15778C2.75698 32.0003 0 29.243 0 25.8421V6.15778ZM15.6901 11.7259H28.1513C30.277 11.7259 32 13.4491 32 15.5746V16.6097C32 18.7352 30.277 20.4585 28.1513 20.4585H15.6901C13.5644 20.4585 11.8412 18.7352 11.8412 16.6097V15.5746C11.8412 13.4491 13.5644 11.7259 15.6901 11.7259Z"
      fill="url(#paint0_radial_102_36)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_102_36"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.888265 -0.888331) rotate(55.378) scale(45.3387 181.167)"
      >
        <stop offset="0.051483" stopColor="#C549FF" />
        <stop offset="0.815643" stopColor="#704BFF" />
      </radialGradient>
    </defs>
  </svg>
);

export default Enkrypt;
